module.exports = __webpack_public_path__ + "static/media/logo148.b1af3807.png";